<mat-drawer-container [hasBackdrop]="true" style="background-color: #ffffff;">
  <mat-drawer
    #drawer
    mode="over"
    [(opened)]="drawerOpen"
    position="end">
    <div class="row" class="side-drawer">
      <div class="col-md-12">
        <button mat-icon-button
          type="button"
          id="close-drawer-icon"
          (click)="drawer.toggle()"
          aria-label="close drawer" class="float-right small-button">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
        <br />
        @if (_drawerContent && _drawerContent.response && _drawerContent.crmQualificationError) {
          <div>
            <h5>We noticed your response...</h5>
            <div [innerHTML]="_drawerContentError"></div>
            <hr />
          </div>
        }
        @if (_drawerContent && _drawerContent.crmQualificationHelp) {
          <div [innerHTML]='_drawerContentHelp'></div>
        }
      </div>
    </div>
    <div class="row" style="margin-right: 0; margin-left: 0;">
      <div class="col-md-12">
        <br />
        <button
          type="button"
          id="close-drawer-button"
          mat-raised-button
          (click)="drawer.toggle()">
          CLOSE
        </button>
      </div>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <section class="row" style="margin-right: 0; margin-left: 0;">
      <div class="col-md-12 questionnaire">
        @if (sortedQuestions.length != 0) {
          <div
            class="progress">
            <div
              class="progress-bar bg-info"
              role="progressbar"
              [ngStyle]="{ 'width': progressDisplay }"
              [attr.aria-valuenow]="progressDisplay"
              aria-valuemin="0"
              aria-valuemax="100">
              Progress {{ progressIndicator }}/{{ sortedQuestions.length }}
            </div>
          </div>
        }
        <br/>
        @if (sortedQuestions.length == 0) {
          <div>
            Error: No qualification questions are available for this program. Please contact support if you continue to get this error.<br /><br />
            <button
              mat-button
              class="go-back"
              id="go-back-button"
              (click)="previousPage()">
              GO BACK
            </button>
          </div>
        }
        @if (questionForm) {
          <form [formGroup]="questionForm">
            @for (questionSet of sortedQuestions; track questionSet; let i = $index) {
              <div>
                @if (progressIndicator === questionSet[0].questionSet) {
                  <div
                    class="row"
                    [formGroupName]="'set' + (i + 1)">
                    @for (question of questionSet; track question) {
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-12 question-sentence" [innerHTML]="question.questionSentence"></div>
                          @if (question.definitions) {
                            <div class="col-md-12 question-definitions" [innerHTML]="question.definitions"></div>
                          }
                        </div>
                        <div class="row" >
                          <div [className]="question.inputSelectedValidStyle + ' col-md-12'">
                            <!-- Yes-No Question -->
                            @if (question.inputTypeOptionSet !== 'Select') {
                              <mat-button-toggle-group [id]="question.controlName"
                                [formControlName]="question.controlName"
                                (change)="qualifierAnswered($event.value, question)" >
                                <mat-button-toggle value="Yes" [id]="(question.controlName + 'Yes')">
                                  YES
                                </mat-button-toggle>
                                <mat-button-toggle color="accent" value="No" [id]="(question.controlName + 'No')">
                                  NO
                                </mat-button-toggle>
                              </mat-button-toggle-group>
                            }
                            <!-- /Yes-No Question -->
                            <!-- Select Question -->
                            @if (question.inputTypeOptionSet === 'Select') {
                              <div style="display: inline-flex;">
                                <mat-form-field
                                  appearance="outline">
                                  <mat-label>Choose an option</mat-label>
                                  <mat-select
                                    [id]="(question.controlName)"
                                    [formControlName]="question.controlName"
                                    (selectionChange)="qualifierAnswered($event.value, question)">
                                    @for (answer of question.inputValues; track answer; let i = $index) {
                                      <mat-option
                                        [id]="(question.controlName + i)"
                                        [value]="answer">
                                        {{ answer }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                                @if (question.controlName === 'source' && question.inputSelectedValue && question.inputSelectedValue.trim() === 'Other') {
                                  <mat-form-field appearance="outline"
                                    >
                                    <mat-label>Please Specify Other:</mat-label>
                                    <input
                                      matInput
                                      [formControlName]="(question.controlName + 'Other')"
                                      class="row"
                                      type="text"
                                      [id]="(question.controlName + 'Other')"
                                      maxlength="60"
                                      (blur)="qualifierOtherAnswered($event, question)"
                                      >
                                    </mat-form-field>
                                  }
                                </div>
                              }
                              <!-- /Select Question -->
                              <div class="question-status">
                                <mat-icon class="valid" aria-hidden="false" [attr.aria-label]="question.questionHelpMessage">check_circle</mat-icon>
                                <mat-icon class="invalid" aria-hidden="false" [attr.aria-label]="question.questionHelpMessage">error</mat-icon>
                              </div>
                              <!-- More Information -->
                              <button
                                mat-button
                                [hidden]="!showMoreInfo(question)"
                                type="button"
                                [id]="(question.controlName + '-more-info')"
                                class="more-info"
                                [attr.aria-label]="('More Info: ' + question.questionSentence)"
                                (click)="qualifierMoreInfo(question)">
                                MORE INFO
                              </button>
                              <!-- /More Information -->
                            </div>
                          </div>
                          <br/>
                          <br/>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <button
                mat-button
                class="go-back"
                id="go-back-stepper-button"
                (click)="previousPage()">
                GO BACK
              </button>
              @if (progressIndicator !== sortedQuestions.length) {
                <button
                  mat-raised-button
                  type="button" color="primary"
                  class="next-step float-right"
                  id="section-stepper-button"
                  (click)="nextPage()"
                  [disabled]="!nextStepEnabled(progressIndicator)">
                  NEXT STEP
                </button>
              }
              @if (progressIndicator === sortedQuestions.length) {
                <button
                  mat-raised-button
                  matStepperNext
                  type="button" color="primary"
                  class="next-step float-right"
                  id="main-stepper-button"
                  [disabled]="!nextStepEnabled(progressIndicator)">
                  NEXT STEP
                </button>
              }
              <br /><br /><br />
            </form>
          }
        </div>
      </section>
    </mat-drawer-content>
  </mat-drawer-container>
